import { DASHBOARD_PROMPT_LINE_HEIGHT_PX } from '../DashboardPromptInput/DashboardPromptInput.styles';

// The prompt box stops growing here and scrolls internally instead.
export const DASHBOARD_PROMPT_MAX_ROWS = 18;

// Thresholds are a pair, not a single value: hiding the template row can remove the page scrollbar,
// which widens the prompt box and re-wraps the text back under a single threshold. The ~2-line dead
// band between them makes that oscillation impossible.
export const TEMPLATE_ROW_HIDE_ABOVE_PX = DASHBOARD_PROMPT_LINE_HEIGHT_PX * 12;
export const TEMPLATE_ROW_SHOW_BELOW_PX = DASHBOARD_PROMPT_LINE_HEIGHT_PX * 10;

export const DASHBOARD_TEMPLATE_TILE_BADGE = 'Template';
